import { IPlainAction } from "../../IPlainAction";

const UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_SET =
  "UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_SET";
export const setPageLoadingFlag = (): IPlainAction<null> => ({
  type: UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_SET,
  payload: null,
});
const UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_CLEARED =
  "UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_CLEARED";
export const clearPageLoadingFlag = (): IPlainAction<null> => ({
  type: UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_CLEARED,
  payload: null,
});

const UI_WORKFLOW_PAGE_FATAL_ERROR_WAS_SET =
  "UI_WORKFLOW_PAGE_FATAL_ERROR_WAS_SET";
export const setFatalError = (message: string): IPlainAction<string> => ({
  type: UI_WORKFLOW_PAGE_FATAL_ERROR_WAS_SET,
  payload: message,
});

export interface IUiWorkflowViewPageState {
  pageIsLoading: boolean;
  fatalError: string | null;
}
const defaultState: IUiWorkflowViewPageState = {
  pageIsLoading: false,
  fatalError: null,
};
export default function uiWorkflowPageReducer(
  state: IUiWorkflowViewPageState = defaultState,
  action: IPlainAction<any>,
): IUiWorkflowViewPageState {
  switch (action.type) {
    case UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_SET:
      return {
        ...state,
        pageIsLoading: true,
      };
    case UI_WORKFLOW_PAGE_LOADING_FLAG_WAS_CLEARED:
      return {
        ...state,
        pageIsLoading: false,
      };
    case UI_WORKFLOW_PAGE_FATAL_ERROR_WAS_SET:
      return {
        ...state,
        fatalError: action.payload,
      };
    default:
      return state;
  }
}
